webpackJsonp([234153087885123],{

/***/ 770:
/***/ (function(module, exports) {

	module.exports = {"data":{"allMarkdownRemark":{"totalCount":1,"edges":[{"node":{"fields":{"slug":"/dealing-with-rodents/"},"excerpt":"Do you have a rodent infestation? Are they eating your cheese or your crops and leaving their droppings all over the place? Then I’m your…","timeToRead":1,"frontmatter":{"title":"Dealing With Rodents","tags":["birds","pest control","rodents"]}}}]}},"pathContext":{"tag":"pest control"}}

/***/ })

});


// WEBPACK FOOTER //
// path---tags-pest-control-9c1d7ccb3c37375800f2.js